<template>
    <div class="evaluation-page">
        <h1>{{ quizResult?.name }}</h1>

        <div class="data-frame" v-if="quizResult">
            <h2>{{ levelTrad[quizResult.level] }}</h2>
        </div>

        <div class="indicator-frame" v-if="quizResult">
            <div class="left-indicator">{{ toPercent(quizResult.scoreGlobal) }}</div>
            
            <div class="right-indicator">
                <p>Un score de 80% permet de valider un niveau</p>
                <table>
                    <tr v-if="quizResult.scoreDifficulty1 != undefined">
                        <th>Niveau intermédiaire</th>
                        <td>{{ toPercent(quizResult.scoreDifficulty1) }}</td>
                    </tr>

                    <tr v-if="quizResult.scoreDifficulty2 != undefined">
                        <th>Niveau confirmé</th>
                        <td>{{ toPercent(quizResult.scoreDifficulty2) }}</td>
                    </tr>

                    <tr v-if="quizResult.scoreDifficulty3 != undefined">
                        <th>Niveau expert</th>
                        <td>{{ toPercent(quizResult.scoreDifficulty3) }}</td>
                    </tr>

                    <tr v-if="quizResult.scoreDifficulty4 != undefined">
                        <th>Niveau expert+</th>
                        <td>{{ toPercent(quizResult.scoreDifficulty4) }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="answer-frame" v-if="quizResult">
            <div class="question-box" v-for="(question, index) in quizResult.correctedQuestions" :key="index">
                <h3>{{ index + 1 }} : {{ question.text }}</h3>

                <div class="options">
                    <div class="option" v-for="option in question.options" :key="option._id">
                        <input type="checkbox" v-model="option.selected" disabled>
                        <h4>{{ option.text }}</h4>
                        <span class="material-symbols-outlined correct-icon"  v-if="option.is_valid">check</span>
                        <span class="material-symbols-outlined incorrect-icon" v-else>close</span>
                    </div>
                </div>

                <div class="confidence-box">
                    <div :class="{ 'selected': question.confidenceLevel == 'high' }">Très sûr</div>
                    <div :class="{ 'selected': question.confidenceLevel == 'medium' }">Moyennement sûr</div>
                    <div :class="{ 'selected': question.confidenceLevel == 'low' }">Peu sûr</div>
                </div>

                <div class="score-wrapper">
                    <span v-if="question.hasGoodAnswer">Bonne réponse : + {{ question.score }}pt</span>
                    <span v-else>Mauvaise réponse : {{ question.score }}pt</span>
                </div>

                <div class="answer-text">{{ question.answer_text }}</div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            quizResult: undefined,
            levelTrad: {
                0: "Débutant",
                1: "Intermédiaire",
                2: "Confirmé",
                3: "Expert",
                4: "Expert+",
            }
        }
    },
    methods: {
        goToLendingPage() {
            this.$router.replace("/academy-learner");
        },
        async getEvaluationResult() {
            const res = await axios.get(this.$store.getters.get_api_url + 'academy/find-result/' + this.$route.params.quizId);
            this.quizResult = res.data;
        },
    },
    mounted() {
        this.getEvaluationResult();
    }
}
</script>

<style scoped>
.evaluation-page {
    width: 800px;
    margin: 30px auto;
}

.data-frame {
    margin: 10px 0;
    padding: 20px;
    border-radius: 20px;
    background-color: white;
}
.data-frame h2 {
    text-align: center;
    color: #0A1C6B;
}

.indicator-frame {
    display: flex;
    justify-content: space-between;
}
.indicator-frame .left-indicator {
    border-radius: 20px;
    padding: 20px;
    flex-basis: 43%;
    text-align: center;
    font-size: 34px;
    font-weight: bold;
    margin: 0;
    background-color: white;
    color: #FB984B;
    display: flex;
    justify-content: center;
    align-items: center;
}
.indicator-frame .right-indicator {
    border-radius: 20px;
    padding: 20px;
    flex-basis: 45%;
    background-color: white;
}
.indicator-frame .right-indicator p {
    color:#0A1C6B;
    text-align: center;
    font-weight: bold;
}

ul {
    list-style: none;
    padding-left: 0;
}

ul.points-list li::before {
    content: "✅ ";
    margin-right: 0.5em;
}

ul.malus-list li::before {
    content: "❌ ";
    margin-right: 0.5em;
}

.btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
}

.btn-wrapper div {
    cursor: pointer;
    padding: 15px;
    background-color: #FB984B;
    color: white;
    font-weight: bold;
    border-radius: 10px;
}

/* Réponses au questionnaire */
.answer-frame {
    display: flex;
    flex-direction: column;
}

.question-box {
    margin: 5px;
    padding: 10px 15px;
    border-radius: 10px;
    background-color: white;
}

.question-box h3 {
    font-size: 14px;
}

.options {
    display: flex;
    flex-direction: column;
}

.options .option {
    display: flex;
    align-items: center;
    padding: 5px;
}

.options .option h4 {
    padding: 0;
    margin: 0;
    font-size: 12px;
    font-weight: lighter;
    margin-left: 10px;
}

.confidence-box {
    width: 500px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: center;
}

.confidence-box div {
    cursor: pointer;
    padding: 10px;
    text-align: center;
    flex-basis: 33%;
    background-color: #f8F4EB;
    font-size: 12px;
}

.confidence-box div:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-right: 1px solid white;
}

.confidence-box div:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-left: 1px solid white;
}

.confidence-box div.selected {
    background-color: #0A1C6B;
    color: white;
}

.correct-icon {
    color: green;
}
.incorrect-icon {
    color: red;
}

.score-wrapper {
    padding: 15px;
    margin: 5px;
    font-weight: bold;
}
.answer-text {
    padding: 15px;
    text-align: justify;
    background-color: rgba(144, 238, 144, 0.242);
    border-radius: 10px;
}
</style>